const APP_SWITCHER_TARGET_ID = 'm_app_switcher';
const FUNCTIONAL_TEST_ID_ATTR = 'data-testid';
const NAV_MENU_DOM_TARGET_ID = 'app_switcher_nav_dom_node';
const NAV_DOM_ID = 'app_switcher_nav_menu';
const MENU_DOM_ID = 'app_switcher_menu_content';
const PROGRAMS_DOM_ID = 'app_switcher_programs_content';
export { APP_SWITCHER_TARGET_ID, FUNCTIONAL_TEST_ID_ATTR, NAV_MENU_DOM_TARGET_ID, NAV_DOM_ID, MENU_DOM_ID, PROGRAMS_DOM_ID };
